module.exports = __webpack_public_path__ + "img/back-chuangjiandingdan.9d3fd114.png";